/* KleenKick V3 — Carusel DM Social Proof (Embla + AutoScroll cinematic) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {
    const roots = document.querySelectorAll('[data-kk-embla]');
    if (!roots.length) return;

    // Resolve UMD globals — handle both direct function and { default: fn }
    const rawEmbla = window.EmblaCarousel;
    const rawAutoScroll = window.EmblaCarouselAutoScroll;
    const EmblaCtor = typeof rawEmbla === 'function' ? rawEmbla : (rawEmbla && rawEmbla.default);
    const AutoScrollCtor = typeof rawAutoScroll === 'function' ? rawAutoScroll : (rawAutoScroll && rawAutoScroll.default);

    if (!EmblaCtor) {
      console.warn('[KleenKick] Embla Carousel not loaded — fallback to static layout');
      roots.forEach((r) => r.classList.add('is-fallback'));
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const viewport = root.querySelector('.kk-social__viewport');
      if (!viewport) return;

      // Speed: px/frame (~60fps). 1 = ~60px/sec. We want ~35px/sec → 0.6
      const speedAttr = parseFloat(root.dataset.kkEmblaSpeed);
      const speed = !isNaN(speedAttr) ? speedAttr : 0.6;

      const plugins = [];
      if (!reducedMotion && AutoScrollCtor) {
        plugins.push(AutoScrollCtor({
          speed: speed,
          startDelay: 800,
          direction: 'forward',
          playOnInit: true,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
          stopOnFocusIn: true
        }));
      }

      const embla = EmblaCtor(viewport, {
        loop: true,
        align: 'start',
        skipSnaps: false,
        dragFree: true,
        containScroll: 'trimSnaps',
        watchDrag: true
      }, plugins);

      // --- Dots ---
      const dotsContainer = root.querySelector('[data-kk-embla-dots]');
      let dotNodes = [];
      if (dotsContainer) {
        const snaps = embla.scrollSnapList();
        dotsContainer.innerHTML = '';
        snaps.forEach((_, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kk-embla__dot';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Mergi la DM ' + (i + 1));
          btn.addEventListener('click', () => {
            embla.scrollTo(i);
            const autoScroll = embla.plugins() && embla.plugins().autoScroll;
            if (autoScroll) {
              autoScroll.stop();
              setTimeout(() => autoScroll.play(), 2500);
            }
          });
          dotsContainer.appendChild(btn);
          dotNodes.push(btn);
        });
      }

      function syncDots() {
        if (!dotNodes.length) return;
        const sel = embla.selectedScrollSnap();
        dotNodes.forEach((d, i) => {
          d.classList.toggle('is-active', i === sel);
          d.setAttribute('aria-selected', i === sel ? 'true' : 'false');
        });
      }

      // --- Arrows ---
      const prevBtn = root.querySelector('[data-kk-embla-prev]');
      const nextBtn = root.querySelector('[data-kk-embla-next]');
      function pauseAndResume() {
        const autoScroll = embla.plugins() && embla.plugins().autoScroll;
        if (autoScroll) {
          autoScroll.stop();
          setTimeout(() => autoScroll.play(), 2500);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', () => { embla.scrollPrev(); pauseAndResume(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { embla.scrollNext(); pauseAndResume(); });

      embla.on('select', syncDots);
      embla.on('reInit', syncDots);
      syncDots();

      // Keyboard support on root
      root.setAttribute('tabindex', '0');
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); embla.scrollPrev(); pauseAndResume(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); embla.scrollNext(); pauseAndResume(); }
      });

      root.classList.add('is-ready');
    });
  });
})();
